import React, { useState } from "react";
import { ColumnsType } from "antd/es/table";
import { Button, Pagination, Popover, Space, Table, Tag, Tooltip } from "antd";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import DeleteSimManagement from "./DeleteSimManagement";
const ListComponent: React.FC<any> = (props) => {
  const {
    listData,
    savePayload,
    tableloading,
    setListData,
    setTableLoading,
    setPaginationData,
    getList,
    paginationData,
    totalData,
    handleEditModal,
  } = props;

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(true);
    setOpenDeleteData(record);
  };
  const handleDeleteRequestClose = () => {
    setOpenDeleteModal(false);
  };
  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };
  const TextWithTooltip = (data: any) => {
    if (data && data?.length > 50) {
      return (
        <span>
          <Popover overlayClassName="desTooltip" title={data} trigger={"hover"}>
            <span style={{ cursor: "pointer" }}>{data.slice(0, 50)}...</span>
          </Popover>
        </span>
      );
    } else {
      return <span>{data}</span>;
    }
  };
  const columns: ColumnsType<any> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 100,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.id?.toString().localeCompare(b?.id),
    },
    {
      title: "ICC ID",
      dataIndex: "icicid",
      key: "icicid",
      width: 150,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.icicid?.toString().localeCompare(b?.icicid),
      render: (_, record) => {
        return record?.icicid ? record?.icicid : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Number",
      dataIndex: "number",
      key: "number",
      width: 250,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.number?.toString().localeCompare(b?.number),
      render: (_, record) => {
        return record?.number ? record?.number : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 250,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.name?.toString().localeCompare(b?.name),
      render: (_, record) => {
        return record?.name ? record?.name : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.description?.localeCompare(b?.description),
      render: (_, record) => {
        return record?.description && record?.description?.length > 0 ? (
          <>{TextWithTooltip(record.description)}</>
        ) : (
          CONSTANT.NO_DATA_FOUND
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 250,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.status?.toString().localeCompare(b?.status),
      render: (_, record) => {
        return record?.status === true ? (
          <Tag color="#87d068">Enabled</Tag>
        ) : (
          <Tag color="#DC863D">Disabled</Tag>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.createdAt?.toString().localeCompare(b?.createdAt),
      render: (_, record) => {
        return record?.createdAt ? record?.createdAt : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      fixed: "right",
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip title={"Edit"}>
              <Button
                type="default"
                icon={<EditOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleEditModal(record)}
              />
            </Tooltip>
            <Tooltip title={"Delete"}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={listData}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.page_number}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size ?? 10}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>
      <DeleteSimManagement
        open={openDeleteModal}
        deleteValues={openDeleteData}
        title={openDeleteData?.number}
        close={handleDeleteRequestClose}
        name={"Number"}
        getList={getList}
      />
    </>
  );
};

export default ListComponent;
